import { useState, useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Route, Routes } from 'react-router-dom';
import customHeaders, { getSpace } from '../../common/headers';
import useGeneralStore from '../../store/general';
import { RavshanHttps } from '../../fetchUrls';
import CalendarDay from './CalendarDay/CalendarDay';
import CalendarWeek from './CalendarWeek/CalendarWeek';
import CalendarMonth from './CalendarMonth/CalendarMonth';
import CalendarToolBarTop from './CalendarToolbarTop/CalendarToolbarTop';
import ModalInfoEvent from '../../components/Modal/ModalInfoEvent/ModalInfoEvent';
import { ModalAddTask } from '../../components/Modal/ModalAddTask/ModalAddTask';
import { ModalCardEvent } from './ModalCardEvent/ModalCardEvent';
import { useMemo } from 'react';
import { useResponseHandler } from '../../common/auth';
import { ModalCreateCalendarFields } from './ModalCreateCalendarFields/ModalCreateCalendarFields';

import "./Calendar.scss";

// Форматирование даты, плюс три часа
const convertDate = (dateString) => {
  const [datePart, timePart] = dateString.split(' ');

  // Разделяем дату на день, месяц и год
  const [day, month, year] = datePart.split('-');

  // Формируем новый формат: YYYY-MM-DDTHH:mm:ss.sssZ
  const formattedDate = `${year}-${month}-${day}T${timePart}:00.000Z`;
  return formattedDate;
};


const options_prop = [
  {
    label: 'Мероприятие',
    value: 'Мероприятие'
  },
  {
    label: 'Задача',
    value: 'Задача'
  },
];

const DAY_IN_MS = 86400000;
const HOUR_IN_MS = 3600000;
const MINUTE_IN_MS = 60000;

const timeDay = Array.from({ length: 25 }, (_, i) => i);
const timeMonth = Array.from({ length: 6 }, (_, i) => i + 1);

const getDateDetails = (date) => ({
  date: new Date(date),
  day: new Date(date).getDate(),
  week: new Date(date).getDay(),
  month: new Date(date).getMonth(),
  hours: new Date(date).getHours(),
  minutes: new Date(date).getMinutes(),
});

const generateWeekDays = (startDate) => {
  const days = [];

  for (let i = -2; i <= 4; i++) {
    const date = new Date(startDate.getTime() + i * DAY_IN_MS);
    days.push(getDateDetails(date));
  }

  return days;
};

function convertUTCtoTimezone(utcString, offsetHours = 3) {
  const date = new Date(utcString);

  // Создаем новую дату с учетом смещения
  const offsetDate = new Date(date.getTime() + offsetHours * 3600000);

  // Получаем компоненты даты
  const year = offsetDate.getUTCFullYear();
  const month = String(offsetDate.getUTCMonth() + 1).padStart(2, '0');
  const day = String(offsetDate.getUTCDate()).padStart(2, '0');
  const hours = String(offsetDate.getUTCHours()).padStart(2, '0');
  const minutes = String(offsetDate.getUTCMinutes()).padStart(2, '0');
  const seconds = String(offsetDate.getUTCSeconds()).padStart(2, '0');

  // Миллисекунды (преобразуем в микросекунды - добавляем три нуля)
  const ms = String(date.getUTCMilliseconds()).padStart(3, '0');
  const microseconds = ms + '000'; // .000 становится .000000

  // Формируем смещение часового пояса
  const offsetSign = offsetHours >= 0 ? '+' : '-';
  const offsetAbs = String(Math.abs(offsetHours)).padStart(2, '0');
  const timezone = `${offsetSign}${offsetAbs}:00`;

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${microseconds}${timezone}`;
}

const Calendar = () => {
  const selectedSpace = useGeneralStore(state => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleStatusCode } = useResponseHandler();
  const [eventList, setEventList] = useState([])

  // Modal
  const [modalInfo, setModalInfo] = useState(false);
  const [isModalFields, setIsModalFields] = useState(false);

  const [eventInfo, setEventInfo] = useState({});
  const [activeContent, setActiveContent] = useState('Мероприятие');
  const [eventsList, setEventsList] = useState([]);
  const [eventsListObj, setEventsListObj] = useState([]);
  const [selectView, setSelectView] = useState('Calendar');
  const [startDate, setStartDate] = useState(new Date());
  const [currentDate, setCurrentDate] = useState(new Date());
  const [newEvent, setNewEvent] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [addEvent, setAddEvent] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState({
    label: '7 Д',
    value: 'week'
  });
  const [id, setId] = useState('');

  // Фильтры
  const [search, setSearch] = useState('')
  const [selectedTypeEvent, setSelectedTypeEvent] = useState([{ label: 'Все', value: 'all' }])

  // Период для отправки
  // const [currentPeriod, setCurrentPeriod] = useState([
  //   new Date(startDate).setHours(0, 0, 0, 0),
  //   new Date(startDate).setHours(23, 59, 59, 999)
  // ])

  // Модальные окна
  const [isModalCard, setIsModalCard] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null)

  const [isModal, setIsModal] = useState(false);
  const [isModalInfo, setIsModalInfo] = useState(false);

  // Установка периода для получения событий - ИСПРАВЛЕННАЯ ЛОГИКА
  const currentPeriod = useMemo(() => {
    const date = new Date(startDate);

    if (selectedPeriod?.value === 'day') {
      const start = new Date(date);
      start.setHours(0, 0, 0, 0);
      const end = new Date(date);
      end.setHours(23, 59, 59, 999);
      return [start, end];
    }

    if (selectedPeriod?.value === 'week') {
      const startOfWeek = new Date(date);
      const day = startOfWeek.getDay();
      const diff = startOfWeek.getDate() - day + (day === 0 ? -6 : 1);
      startOfWeek.setDate(diff);
      startOfWeek.setHours(0, 0, 0, 0);

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      endOfWeek.setHours(23, 59, 59, 999);
      return [startOfWeek, endOfWeek];
    }

    if (selectedPeriod?.value === 'month') {
      const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      startOfMonth.setHours(0, 0, 0, 0);

      const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      endOfMonth.setHours(23, 59, 59, 999);
      return [startOfMonth, endOfMonth];
    }

    const start = new Date(date);
    start.setHours(0, 0, 0, 0);
    const end = new Date(date);
    end.setHours(23, 59, 59, 999);
    return [start, end];
  }, [startDate, selectedPeriod]);

  const refHeaderTop = useRef();

  const dateNow = [getDateDetails(startDate)];

  const [currentDay, setCurrentDay] = useState(
    getDateDetails(new Date())
  );

  const weekHeader = generateWeekDays(startDate);

  useEffect(() => {
    setCurrentDay(getDateDetails(currentDate));
  }, [currentDate]);

  useEffect(() => {
    if (currentDate) {
      setStartDate(currentDate);
    }
  }, [currentDate]);


  // Получить события - ИСПРАВЛЕННАЯ ЛОГИКА
  const fetchGetEvents = (abortController = new AbortController()) => {
    let url = `https://apps0.ecomru.ru:4553/api/v1/event/list-grouped`;

    // Функция для форматирования даты в UTC, сохраняя локальное время
    const formatDateForAPI = (date) => {
      if (!date) return '';
      // Создаем новую дату с теми же локальными компонентами, но в UTC
      const utcDate = new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
      ));
      return utcDate.toISOString();
    };

    const event_type_ids = selectedTypeEvent?.[0]?.value === 'all' ? [1, 2] : selectedTypeEvent?.map(({ value }) => value)

    const body = JSON.stringify({
      ids: [],
      event_type_ids,
      title: search,
      start_time_from: currentPeriod?.[0] ? convertUTCtoTimezone(new Date(currentPeriod[0])) : '',
      start_time_to: currentPeriod?.[1] ? convertUTCtoTimezone(new Date(currentPeriod[1])) : '',
      is_deleted: false
    })

    return fetch(url, { body, method: 'POST', headers, signal: abortController.signal, })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          // handleStatusCode(res.status);
        }
      })
      .then(json => {
        if (Array.isArray(json)) {
          setEventList(json)
        }
        return json;
      })
      .catch(err => {
        throw err;
      })
      .finally(() => {
        if (abortController.signal.aborted) return;
      });
  };

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['events', currentPeriod, isModal, isModalCard, search, selectedTypeEvent],
    queryFn: () => fetchGetEvents(),
    enabled: !isModal && !isModalCard, // Автоматически предотвращает лишние вызовы
    // staleTime: 60 * 1000, // 1 минута - данные считаются свежими
    // gcTime: 60 * 1000, // 5 минут кэша
  });

  const fetchEventData = (id) => {
    let url = `${RavshanHttps}/api/calendar/get_calendar_event`;

    fetch(url, { method: 'GET', headers: { ...headers, 'event-id': id } })
      .then(res => res.json())
      .then(json => {
        const { event } = json;
        if (event) {
          const eventInfo = {
            id: event[1][0],
            title: event[1][1],
            dateFrom: event[1][3],
            dateTo: event[1][4],
            description: event[1][5],
            type: event[1][2]
          };
          setEventInfo(eventInfo);
          setId(id);
          setIsModal(true);
        }
      })
      .catch(err => console.error(err));
  };

  const calendarCommonProps = {
    startDate,
    refHeaderTop,
    setAddEvent,
    setReadOnly,
    setNewEvent,
    eventsList,
    setEventInfo,
    fetchEventData,
    weekHeader,
    dateNow,
    isModal,
    setIsModal,
    events_list: eventList,
    selectedEvent,
    setSelectedEvent,
    setIsModalCard
  };

  const modalAddTaskProps = {
    id,
    addEvent,
    setAddEvent,
    modalInfo,
    setModalInfo,
    eventInfo,
    setEventInfo,
    setNewEvent,
    setCurrentDate,
    fetchEventData,
    currentDate,
    activeContent,
    setActiveContent,
    setIsModal,
    readOnly,
    options: options_prop,
    selectedEvent,
    setSelectedEvent
  };

  const toolbarProps = {
    search,
    setSearch,
    selectedTypeEvent,
    setSelectedTypeEvent,
    ////////
    refHeaderTop,
    selectView,
    setSelectView,
    currentDate,
    weekHeader,
    selectedPeriod,
    setSelectedPeriod,
    startDate,
    setStartDate,
    setCurrentDate,
    setEventInfo,
    setReadOnly,
    setAddEvent,
    setIsModal,
    setIsModalFields
  };

  const dayProps = {
    ...calendarCommonProps,
    eventsListObj,
    currentDay,
    time: timeDay,
  };

  const weekProps = {
    ...calendarCommonProps,
    timeDay,
  };

  const monthProps = {
    ...calendarCommonProps,
    eventsListObj,
    timeDay,
  };

  return (
    <div className='calendar-page'>

      {/* Создание полей */}
      {isModalFields &&
        <ModalCreateCalendarFields
          setIsModal={setIsModalFields}
        />}


      {isModalInfo && (
        <ModalInfoEvent
          eventInfo={eventInfo}
          setIsModalInfo={(e) => setIsModalInfo(e)}
        />
      )}

      {isModal && (
        <ModalAddTask
          {...modalAddTaskProps}
        />
      )}

      {/* Карточка события */}
      {isModalCard &&
        <ModalCardEvent
          setIsModal={setIsModalCard}
          setIsModalEdit={setIsModal}
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
        />}

      <div className='calendar-page__content'>


        <CalendarToolBarTop {...toolbarProps} />

        <Routes>
          <Route
            path="/day"
            element={<CalendarDay {...dayProps} />}
          />

          <Route
            path="/week"
            element={<CalendarWeek {...weekProps} />}
          />

          <Route
            path="/month"
            element={<CalendarMonth {...monthProps} />}
          />
        </Routes>
      </div>
    </div>
  );
};

export { Calendar };